// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"565cbe91","455":"efdb7d87","977":"add1d92c"}[chunkId] + ".chunk.js";
};